import { useRef, useState } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";

export default function TourVideo() {
  const videoRef = useRef(null);
  const [started, setStarted] = useState(false);

  const start = () => {
    setStarted(true);
    requestAnimationFrame(() => {
      videoRef.current?.play().catch(() => {});
    });
  };

  return (
    <div
      data-testid="tour-video-frame"
      className="relative aspect-video w-full overflow-hidden rounded-xl border border-slate-200 bg-obsidian shadow-2xl"
    >
      <video
        ref={videoRef}
        data-testid="tour-video-player"
        className="h-full w-full object-cover"
        poster="/assets/tour-poster.jpg"
        preload="metadata"
        controls={started}
        playsInline
      >
        <source src="/assets/bnm-tour.mp4" type="video/mp4" />
        <track
          kind="captions"
          src="/assets/bnm-tour-captions.vtt"
          srcLang="en"
          label="English captions"
          default
        />
        Your browser does not support the video tag.
      </video>
      {!started && (
        <button
          type="button"
          onClick={start}
          data-testid="tour-video-play"
          aria-label="Play the BNM website tour video"
          className="absolute inset-0 flex items-center justify-center bg-obsidian/20 transition-colors hover:bg-obsidian/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-volt"
        >
          <motion.span
            initial={{ scale: 0.9, opacity: 0.9 }}
            whileHover={{ scale: 1.08 }}
            whileTap={{ scale: 0.96 }}
            transition={{ type: "spring", stiffness: 300, damping: 18 }}
            className="flex h-20 w-20 items-center justify-center rounded-full bg-volt text-obsidian shadow-[0_0_60px_rgba(52,211,153,0.45)]"
          >
            <Play className="h-8 w-8 translate-x-0.5 fill-current" aria-hidden="true" />
          </motion.span>
          <span className="sr-only">Play video: Take a Tour of BNM</span>
        </button>
      )}
    </div>
  );
}
